import { BACKEND } from '../../constants';
import axios from '../../axios';

export const getSoracomInvoicesProcess = (callback) => async (dispatch, getState) => {
    let response
    try {
        response = await axios.get(BACKEND.LIST_INVOICE_DOWNLOAD_PROCESS.uri);
        callback(null, response.data)
    } catch (e) {
        callback(e)
    }
}


export const getInvoiceDownloadProcessDetails = (id, callback) => async (dispatch) => {
    let response
    try {

        response = await axios.get(BACKEND.INVOICE_DOWNLOAD_PROCESS_DETAILS.uri.replace(':?1', id));
        callback(null, response);
    } catch (e) {
        callback(e)
    }
}

export const getAllOperatorsAndNames = (callback) => async (dispatch) => {
    let response
    try {

        response = await axios.get(BACKEND.GET_OPERATORS_AND_NAMES.uri);
        callback(null, response);
    } catch (e) {
        callback(e)
    }
}

export const startSummaryDownload = (billingMonthYear, operatorId, callback) => async (dispatch) => {
    let response
    try {
        response = await axios.post(BACKEND.START_INVOICE_DOWNLOAD_PROCESS.uri, {
            billingMonthYear, operatorId
        });
        callback(null, response);
    } catch (e) {
        callback(e)
    }
}

/**
 * Start billing processing for a completed download run
 */
export const startBillingProcessing = (processId, callback) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/v1/billing-runs/${processId}/start-processing`);
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};

/**
 * Re-process billing for specific invoices
 */
export const reprocessBilling = (processId, options, callback) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/v1/billing-runs/${processId}/reprocess`, options);
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};


/**
 * Re-process billing for a single invoice by invoiceId
 */
export const reprocessSingleInvoice = (processId, invoiceId, callback) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/v1/billing-runs/${processId}/reprocess-single/${invoiceId}`);
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};

/**
 * Re-process billing for a single invoice by operatorId (robust)
 */
export const reprocessSingleInvoiceByOperator = (processId, operatorId, callback) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/v1/billing-runs/${processId}/reprocess-single-by-operator/${operatorId}`);
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};

/**
 * Abort billing processing - cancel all pending jobs
 */
export const abortBillingProcessing = (processId, callback) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/v1/billing-runs/${processId}/abort-processing`);
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};

/**
 * Start billing export - create ZIP of processed invoices
 */
export const startBillingExport = (processId, requestedBy, callback) => async (dispatch) => {
    try {
        const response = await axios.post(`/api/v1/billing-runs/${processId}/start-export`, {
            userId: requestedBy.userId,
            userName: requestedBy.userName,
            email: requestedBy.email
        });
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};

/**
 * Get all exports for a billing run
 */
export const getBillingExports = (processId, callback) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/v1/billing-runs/${processId}/exports`);
        callback && callback(null, response);
    } catch (e) {
        callback && callback(e);
    }
};

/**
 * UI-only mock: Step 2 processing (generate invoices)
 * No backend call yet; used to iterate on UI.
 */
export const mockProcessRawBilling = (processId, options = {}, callback) => async (dispatch) => {
    try {
        // simulate 2-4 seconds completion
        setTimeout(() => {
            callback && callback(null, {
                data: {
                    processId,
                    status: 'COMPLETED',
                    simulated: true,
                    options
                }
            })
        }, 2500);
    } catch (e) {
        callback && callback(e)
    }
}

/**
 * UI-only mock: Step 3 export
 */
export const mockExportToXero = (processId, options = {}, callback) => async (dispatch) => {
    try {
        setTimeout(() => {
            callback && callback(null, {
                data: {
                    processId,
                    status: 'READY',
                    simulated: true,
                    options
                }
            })
        }, 1200);
    } catch (e) {
        callback && callback(e)
    }
}
